module.exports = __webpack_public_path__ + "static/media/slide3.15238518.jpg";